import React, {useEffect, useState} from "react";
import { Button, Col, FormGroup, Modal, Row, Container} from "react-bootstrap";
import { Form, Checkbox ,Input, Select } from 'antd';
import { ImageElement,Breadcrumb, LoginHeader} from "../../components";
import { Link } from "react-router-dom";
const handleChange = (value) => {
    console.log(`selected ${value}`);
};


function BookAppointment() {

    const breadcrumb = [
        {
            path: '/dashboard',
            name: 'Home',
        },
        {
            path: '#',
            name: 'Service Provider List',
        },
    ];
    // Modal
    const [showloader, setloader] = useState(false);
    const loaderShow = () => setloader(true);
    const [show, setShow] = useState(false);
    const handleClose = () => {
        setShow(false);
        setloader(true);
    };
    const handleClose2 = () => {
        setShow(false);
        setloader(false);
    };
    const loaderClose = () => {
        document.querySelector('body').classList.remove('overflow-hidden');
        setloader(false)
    }
    const handleShow = () => setShow(true);
    const { TextArea } = Input;
    useEffect(() => {
        if(showloader){
            document.querySelector('body').classList.add('overflow-hidden');
        }else{
            document.querySelector('body').classList.remove('overflow-hidden');
        }
    });
    return(
        <>            
            <LoginHeader/>         
            <div className="main-content BookAppointmentPage dashboardPage">
                {/* page content */}
                <div className="pageContent">
                    <Container className="container-lg">
                        <Breadcrumb title="Book Appointment" breadcrumb={breadcrumb}/>
                        {/* Service Address */}
                        <div className="serviceAddress bg-white p-30 br-10">
                            <div className="d-flex align-items-lg-center align-items-start flex-lg-row flex-column">
                                <div className="serviceAddress_left">
                                    <h2 className="font-sm">Service Address</h2>
                                    <p className="mb-0 font-md">Vijay Nagar Square, Vijay Nagar, Indore, Madhya Pradesh, India</p>
                                </div>
                                <div className="serviceAddress_right ms-lg-auto">
                                    <div className="d-flex align-items-center">
                                        <Form>
                                            <FormGroup className="form-group d-flex align-items-sm-center mb-0">
                                                <Form.Item label="Sort By" className="mb-0 font-md" >
                                                    <Select defaultValue="serviceProvider1"
                                                        onChange={handleChange} className="w-100 ant-select-lg"
                                                        options={[
                                                            {
                                                            value: 'serviceProvider1',
                                                            label: 'All Service Provider',
                                                            },
                                                            {
                                                            value: 'serviceProvider2',
                                                            label: 'Favorite Service Provider',
                                                            },
                                                        ]}
                                                        />
                                                </Form.Item>
                                                <Button variant="primary" type="submit" className="font-md ms-sm-2">Emergency Request to all</Button>
                                            </FormGroup>
                                        </Form>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {/* Service Address */}
                        <div className="appointmentSection bg-white p-30 br-10">
                            <Row className="g-3">
                                <Col sm={6} lg={4} xxl={3}>
                                    <div className="appointmentList position-relative"> 
                                        <div className="appointmentList_like">
                                            <Checkbox defaultChecked><em className="appointmentList_like_icon gg-heart-outline"/></Checkbox>
                                        </div>
                                        <div className="appointmentList_top d-flex align-items-start">
                                            <div className="appointmentList_top_images">
                                                <ImageElement source="img-1.png" />
                                            </div>
                                            <div className="appointmentList_top_content">
                                                <h2 className="font-md">Steven S. Hurd</h2>
                                                <p className="">HVAC</p>
                                                <ul className="list-inline mb-0">
                                                    <li className="list-inline-item">
                                                        <div className="info">
                                                        <ul className="list-unstyled d-flex starRating mb-0">
                                                            <li><em className="info_icon info_icon-gray gg-full-star active"/></li>
                                                            <li><em className="info_icon info_icon-gray gg-full-star active"/></li>
                                                            <li><em className="info_icon info_icon-gray gg-full-star active"/></li>
                                                            <li className="starRating_halfStar"><em className="info_icon info_icon-gray gg-half-star active_half"/></li>
                                                            <li><em className="info_icon info_icon-gray gg-star-outline active"/></li>
                                                        </ul>
                                                        {/* <span className="info_content">4.2</span> */}
                                                        </div>
                                                    </li>
                                                    {/* <li className="list-inline-item">
                                                        <div className="info">
                                                            <em className="info_icon info_icon-blue gg-marker"/>
                                                            <span className="info_content">2.06 mi</span>
                                                        </div>
                                                    </li> */}
                                                </ul>
                                            </div>
                                        </div>   
                                        <div className="appointmentList_bottom">
                                            <Button variant="outline-primary" className="w-100" onClick={handleShow} >Book Now</Button>
                                        </div>  
                                    </div>
                                </Col>
                                <Col sm={6}  lg={4} xxl={3}>
                                    <div className="appointmentList position-relative">
                                        <div className="appointmentList_like">
                                            <Checkbox defaultChecked><em className="appointmentList_like_icon gg-heart-outline"/></Checkbox>
                                        </div>
                                        <div className="appointmentList_top d-flex align-items-start">
                                            <div className="appointmentList_top_images">
                                                <ImageElement source="img-2.png" />
                                            </div>
                                            <div className="appointmentList_top_content">
                                                <h2 className="font-md">Steven S. Hurd</h2>
                                                <p className="">HVAC</p>
                                                <ul className="list-inline mb-0">
                                                    <li className="list-inline-item">
                                                        <div className="info">
                                                            <ul className="list-unstyled d-flex starRating mb-0">
                                                                <li><em className="info_icon info_icon-gray gg-full-star active"/></li>
                                                                <li><em className="info_icon info_icon-gray gg-full-star active"/></li>
                                                                <li><em className="info_icon info_icon-gray gg-full-star active"/></li>
                                                                <li><em className="info_icon info_icon-gray gg-full-star active"/></li>
                                                                <li className="starRating_halfStar"><em className="info_icon info_icon-gray gg-half-star active_half"/></li>
                                                            </ul>
                                                            {/* <em className="info_icon info_icon-orange gg-star-outline"/>
                                                            <span className="info_content">4.2</span> */}
                                                        </div>
                                                    </li>
                                                    {/* <li className="list-inline-item">
                                                        <div className="info">
                                                            <em className="info_icon info_icon-blue gg-marker"/>
                                                            <span className="info_content">2.06 mi</span>
                                                        </div>
                                                    </li> */}
                                                </ul>
                                            </div>
                                        </div>   
                                        <div className="appointmentList_bottom">
                                            <Button variant="outline-primary" className="w-100" onClick={handleShow} >Book Now</Button>
                                        </div>   
                                    </div>
                                </Col>
                                <Col sm={6}  lg={4} xxl={3}>
                                    <div className="appointmentList position-relative">
                                        <div className="appointmentList_like">
                                            <Checkbox defaultChecked><em className="appointmentList_like_icon gg-heart-outline"/></Checkbox>
                                        </div>
                                        <div className="appointmentList_top d-flex align-items-start">
                                            <div className="appointmentList_top_images">
                                                <ImageElement source="img-3.png" />
                                            </div>
                                            <div className="appointmentList_top_content">
                                                <h2 className="font-md">Steven S. Hurd</h2>
                                                <p className="">HVAC</p>
                                                <ul className="list-inline mb-0">
                                                    <li className="list-inline-item">
                                                        <div className="info">
                                                            <ul className="list-unstyled d-flex starRating mb-0">
                                                                <li><em className="info_icon info_icon-gray gg-full-star active"/></li>
                                                                <li><em className="info_icon info_icon-gray gg-full-star active"/></li>
                                                                <li><em className="info_icon info_icon-gray gg-full-star active"/></li>
                                                                <li><em className="info_icon info_icon-gray gg-full-star active"/></li>
                                                                <li className="starRating_halfStar"><em className="info_icon info_icon-gray gg-half-star active_half"/></li>
                                                            </ul>
                                                        </div>
                                                    </li>
                                                    {/* <li className="list-inline-item">
                                                        <div className="info">
                                                            <em className="info_icon info_icon-blue gg-marker"/>
                                                            <span className="info_content">2.06 mi</span>
                                                        </div>
                                                    </li> */}
                                                </ul>
                                            </div>
                                        </div>   
                                        <div className="appointmentList_bottom">
                                            <Button variant="outline-primary" className="w-100" onClick={handleShow} >Book Now</Button>
                                        </div>   
                                    </div>
                                </Col>
                                <Col sm={6}  lg={4} xxl={3}>
                                    <div className="appointmentList position-relative">
                                        <div className="appointmentList_like">
                                            <Checkbox defaultChecked><em className="appointmentList_like_icon gg-heart-outline"/></Checkbox>
                                        </div>
                                        <div className="appointmentList_top d-flex align-items-start">
                                            <div className="appointmentList_top_images">
                                                <ImageElement source="img-4.png" />
                                            </div>
                                            <div className="appointmentList_top_content">
                                            <h2 className="font-md">Steven S. Hurd</h2>
                                                <p className="">HVAC</p>
                                                <ul className="list-inline mb-0">
                                                    <li className="list-inline-item">
                                                        <div className="info">
                                                            <ul className="list-unstyled d-flex starRating mb-0">
                                                                <li><em className="info_icon info_icon-gray gg-full-star active"/></li>
                                                                <li><em className="info_icon info_icon-gray gg-full-star active"/></li>
                                                                <li><em className="info_icon info_icon-gray gg-full-star active"/></li>
                                                                <li><em className="info_icon info_icon-gray gg-full-star active"/></li>
                                                                <li className="starRating_halfStar"><em className="info_icon info_icon-gray gg-half-star active_half"/></li>
                                                            </ul>
                                                        </div>
                                                    </li>
                                                    {/* <li className="list-inline-item">
                                                        <div className="info">
                                                            <em className="info_icon info_icon-blue gg-marker"/>
                                                            <span className="info_content">2.06 mi</span>
                                                        </div>
                                                    </li> */}
                                                </ul>
                                            </div>
                                        </div>   
                                        <div className="appointmentList_bottom">
                                            <Button variant="outline-primary" className="w-100" onClick={handleShow} >Book Now</Button>
                                        </div>   
                                    </div>
                                </Col>
                                <Col sm={6}  lg={4} xxl={3}>
                                    <div className="appointmentList position-relative">
                                        <div className="appointmentList_like">
                                            <Checkbox><em className="appointmentList_like_icon gg-heart-outline"/></Checkbox>
                                        </div>
                                        <div className="appointmentList_top d-flex align-items-start">
                                            <div className="appointmentList_top_images">
                                                <ImageElement source="img-5.png" />
                                            </div>
                                            <div className="appointmentList_top_content">
                                            <h2 className="font-md">Steven S. Hurd</h2>
                                                <p className="">HVAC</p>
                                                <ul className="list-inline mb-0">
                                                    <li className="list-inline-item">
                                                        <div className="info">
                                                            <ul className="list-unstyled d-flex starRating mb-0">
                                                                <li><em className="info_icon info_icon-gray gg-full-star active"/></li>
                                                                <li><em className="info_icon info_icon-gray gg-full-star active"/></li>
                                                                <li><em className="info_icon info_icon-gray gg-full-star active"/></li>
                                                                <li><em className="info_icon info_icon-gray gg-full-star active"/></li>
                                                                <li className="starRating_halfStar"><em className="info_icon info_icon-gray gg-half-star active_half"/></li>
                                                            </ul>
                                                        </div>
                                                    </li>
                                                    {/* <li className="list-inline-item">
                                                        <div className="info">
                                                            <em className="info_icon info_icon-blue gg-marker"/>
                                                            <span className="info_content">2.06 mi</span>
                                                        </div>
                                                    </li> */}
                                                </ul>
                                            </div>
                                        </div>   
                                        <div className="appointmentList_bottom">
                                            <Button variant="outline-primary" className="w-100" onClick={handleShow} >Book Now</Button>
                                        </div>   
                                    </div>
                                </Col>
                                <Col sm={6}  lg={4} xxl={3}>
                                    <div className="appointmentList position-relative">
                                        <div className="appointmentList_like">
                                            <Checkbox><em className="appointmentList_like_icon gg-heart-outline"/></Checkbox>
                                        </div>
                                        <div className="appointmentList_top d-flex align-items-start">
                                            <div className="appointmentList_top_images">
                                                <ImageElement source="img-1.png" />
                                            </div>
                                            <div className="appointmentList_top_content">
                                            <h2 className="font-md">Steven S. Hurd</h2>
                                                <p className="">HVAC</p>
                                                <ul className="list-inline mb-0">
                                                    <li className="list-inline-item">
                                                        <div className="info">
                                                            <ul className="list-unstyled d-flex starRating mb-0">
                                                                <li><em className="info_icon info_icon-gray gg-full-star active"/></li>
                                                                <li><em className="info_icon info_icon-gray gg-full-star active"/></li>
                                                                <li><em className="info_icon info_icon-gray gg-full-star active"/></li>
                                                                <li><em className="info_icon info_icon-gray gg-full-star active"/></li>
                                                                <li className="starRating_halfStar"><em className="info_icon info_icon-gray gg-half-star active_half"/></li>
                                                            </ul>
                                                        </div>
                                                    </li>
                                                    {/* <li className="list-inline-item">
                                                        <div className="info">
                                                            <em className="info_icon info_icon-blue gg-marker"/>
                                                            <span className="info_content">2.06 mi</span>
                                                        </div>
                                                    </li> */}
                                                </ul>
                                            </div>
                                        </div>   
                                        <div className="appointmentList_bottom">
                                            <Button variant="outline-primary" className="w-100" onClick={handleShow} >Book Now</Button>
                                        </div>   
                                    </div>
                                </Col>
                                <Col sm={6}  lg={4} xxl={3}>
                                    <div className="appointmentList position-relative">
                                        <div className="appointmentList_like">
                                            <Checkbox><em className="appointmentList_like_icon gg-heart-outline"/></Checkbox>
                                        </div>
                                        <div className="appointmentList_top d-flex align-items-start">
                                            <div className="appointmentList_top_images">
                                                <ImageElement source="img-2.png" />
                                            </div>
                                            <div className="appointmentList_top_content">
                                            <h2 className="font-md">Steven S. Hurd</h2>
                                                <p className="">HVAC</p>
                                                <ul className="list-inline mb-0">
                                                    <li className="list-inline-item">
                                                        <div className="info">
                                                            <ul className="list-unstyled d-flex starRating mb-0">
                                                                <li><em className="info_icon info_icon-gray gg-full-star active"/></li>
                                                                <li><em className="info_icon info_icon-gray gg-full-star active"/></li>
                                                                <li><em className="info_icon info_icon-gray gg-full-star active"/></li>
                                                                <li><em className="info_icon info_icon-gray gg-full-star active"/></li>
                                                                <li className="starRating_halfStar"><em className="info_icon info_icon-gray gg-half-star active_half"/></li>
                                                            </ul>
                                                        </div>
                                                    </li>
                                                    {/* <li className="list-inline-item">
                                                        <div className="info">
                                                            <em className="info_icon info_icon-blue gg-marker"/>
                                                            <span className="info_content">2.06 mi</span>
                                                        </div>
                                                    </li> */}
                                                </ul>
                                            </div>
                                        </div>   
                                        <div className="appointmentList_bottom">
                                            <Button variant="outline-primary" className="w-100" onClick={handleShow} >Book Now</Button>
                                        </div>   
                                    </div>
                                </Col>
                                <Col sm={6}  lg={4} xxl={3}>
                                    <div className="appointmentList position-relative">
                                        <div className="appointmentList_like">
                                            <Checkbox><em className="appointmentList_like_icon gg-heart-outline"/></Checkbox>
                                        </div>
                                        <div className="appointmentList_top d-flex align-items-start">
                                            <div className="appointmentList_top_images">
                                                <ImageElement source="img-3.png" />
                                            </div>
                                            <div className="appointmentList_top_content">
                                            <h2 className="font-md">Steven S. Hurd</h2>
                                                <p className="">HVAC</p>
                                                <ul className="list-inline mb-0">
                                                    <li className="list-inline-item">
                                                        <div className="info">
                                                            <ul className="list-unstyled d-flex starRating mb-0">
                                                                <li><em className="info_icon info_icon-gray gg-full-star active"/></li>
                                                                <li><em className="info_icon info_icon-gray gg-full-star active"/></li>
                                                                <li><em className="info_icon info_icon-gray gg-full-star active"/></li>
                                                                <li><em className="info_icon info_icon-gray gg-full-star active"/></li>
                                                                <li className="starRating_halfStar"><em className="info_icon info_icon-gray gg-half-star active_half"/></li>
                                                            </ul>
                                                        </div>
                                                    </li>
                                                    {/* <li className="list-inline-item">
                                                        <div className="info">
                                                            <em className="info_icon info_icon-blue gg-marker"/>
                                                            <span className="info_content">2.06 mi</span>
                                                        </div>
                                                    </li> */}
                                                </ul>
                                            </div>
                                        </div>   
                                        <div className="appointmentList_bottom">
                                            <Button variant="outline-primary" className="w-100" onClick={handleShow} >Book Now</Button>
                                        </div>   
                                    </div>
                                </Col>
                                <Col sm={6}  lg={4} xxl={3}>
                                    <div className="appointmentList position-relative">
                                        <div className="appointmentList_like">
                                            <Checkbox><em className="appointmentList_like_icon gg-heart-outline"/></Checkbox>
                                        </div>
                                        <div className="appointmentList_top d-flex align-items-start">
                                            <div className="appointmentList_top_images">
                                                <ImageElement source="img-4.png" />
                                            </div>
                                            <div className="appointmentList_top_content">
                                            <h2 className="font-md">Steven S. Hurd</h2>
                                                <p className="">HVAC</p>
                                                <ul className="list-inline mb-0">
                                                    <li className="list-inline-item">
                                                        <div className="info">
                                                            <ul className="list-unstyled d-flex starRating mb-0">
                                                                <li><em className="info_icon info_icon-gray gg-full-star active"/></li>
                                                                <li><em className="info_icon info_icon-gray gg-full-star active"/></li>
                                                                <li><em className="info_icon info_icon-gray gg-full-star active"/></li>
                                                                <li><em className="info_icon info_icon-gray gg-full-star active"/></li>
                                                                <li className="starRating_halfStar"><em className="info_icon info_icon-gray gg-half-star active_half"/></li>
                                                            </ul>
                                                        </div>
                                                    </li>
                                                    {/* <li className="list-inline-item">
                                                        <div className="info">
                                                            <em className="info_icon info_icon-blue gg-marker"/>
                                                            <span className="info_content">2.06 mi</span>
                                                        </div>
                                                    </li> */}
                                                </ul>
                                            </div>
                                        </div>   
                                        <div className="appointmentList_bottom">
                                            <Button variant="outline-primary" className="w-100" onClick={handleShow} >Book Now</Button>
                                        </div>   
                                    </div>
                                </Col>
                                <Col sm={6}  lg={4} xxl={3}>
                                    <div className="appointmentList position-relative">
                                        <div className="appointmentList_like">
                                            <Checkbox><em className="appointmentList_like_icon gg-heart-outline"/></Checkbox>
                                        </div>
                                        <div className="appointmentList_top d-flex align-items-start">
                                            <div className="appointmentList_top_images">
                                                <ImageElement source="img-5.png" />
                                            </div>
                                            <div className="appointmentList_top_content">
                                            <h2 className="font-md">Steven S. Hurd</h2>
                                                <p className="">HVAC</p>
                                                <ul className="list-inline mb-0">
                                                    <li className="list-inline-item">
                                                        <div className="info">
                                                            <ul className="list-unstyled d-flex starRating mb-0">
                                                                <li><em className="info_icon info_icon-gray gg-full-star active"/></li>
                                                                <li><em className="info_icon info_icon-gray gg-full-star active"/></li>
                                                                <li><em className="info_icon info_icon-gray gg-full-star active"/></li>
                                                                <li><em className="info_icon info_icon-gray gg-full-star active"/></li>
                                                                <li className="starRating_halfStar"><em className="info_icon info_icon-gray gg-half-star active_half"/></li>
                                                            </ul>
                                                        </div>
                                                    </li>
                                                    {/* <li className="list-inline-item">
                                                        <div className="info">
                                                            <em className="info_icon info_icon-blue gg-marker"/>
                                                            <span className="info_content">2.06 mi</span>
                                                        </div>
                                                    </li> */}
                                                </ul>
                                            </div>
                                        </div>   
                                        <div className="appointmentList_bottom">
                                            <Button variant="outline-primary" className="w-100" onClick={handleShow} >Book Now</Button>
                                        </div>   
                                    </div>
                                </Col>
                            </Row>
                        </div>                        
                    </Container>
                    <div className={`thankyouloader ${!showloader && 'd-none'}`}>
                        <div className="thankyouloader_content">
                            <h2>Thank you for choosing us!</h2>
                            <div className="thankyouloader_sec d-flex justify-content-center align-items-center mx-auto">    
                                <Link to="">
                                    <ImageElement source="loader-img.svg" />
                                </Link>  
                            </div>  
                            <Link to="/my-bookings" onClick={() => loaderClose()} className="thankyouloader_closebtn d-flex justify-content-center align-items-center"> 
                                <em className="gg-close"></em>                               
                            </Link>                                         
                        </div>
                    </div>
                </div>
            </div>
             {/* add location */}
             <Modal show={show} onHide={handleClose2} size="lg" centered id="addLocation" className="bookingDetails" backdrop="static">
                <Modal.Header closeButton className="align-items-start">
                    <div>
                        <Modal.Title>Booking Details</Modal.Title>
                    </div>
                </Modal.Header>
                <Modal.Body>
                        <Row className="align-items-center">
                        <ul className="bookingDetails list-unstyled mb-0">
                            <li className="bookingDetails_list d-flex">
                                <label>Paid Schedule <span>X 1</span></label>
                                <span className="font-sm">$100</span>
                            </li>
                            <li className="bookingDetails_list d-flex">
                                <label>Provider</label>
                                <span className="font-sm">James John</span>
                            </li>
                            <li className="bookingDetails_list d-flex">
                                <label>Company Name</label>
                                <span className="font-sm">Versatile Sash & Woodwork</span>
                            </li>
                            <li className="bookingDetails_list d-flex">
                                <label>Booking Date</label>
                                <span className="font-sm">Jan 25,2023</span>
                            </li>
                            <li className="bookingDetails_list d-flex">
                                <label>Booking Time</label>
                                <span className="font-sm">11:00 AM - 02:00 PM</span>
                            </li>
                        </ul>
                        </Row>
                        <div className="promoCode">
                            <Form className="d-flex align-items-end">
                                <FormGroup className="form-group promoCode_wrapper mb-0">
                                        <label className="ant-label font-md">Promo Code</label>
                                    <Input size="large" placeholder="Promo Code" value="NIT" />
                                </FormGroup>
                                <Button variant="primary" type="submit" className="ms-2 font-sm d-inline-block">APPLY</Button>
                            </Form>
                            <div className="promoCode_info mt-2 d-flex align-items-center"><em className="gg-check-circle me-2"/> <span>Promo Code applied!</span></div>
                        </div>
                        <div className="mb-3">
                            <ul className="serviceCost list-unstyled mt-lg-0 mt-3 mb-0">
                                <li className="serviceCost_list">
                                    <label>Total Cost</label>
                                    <span className="font-sm">$98.98</span>
                                </li>      
                            </ul>
                        </div>
                        <FormGroup className="form-group">
                            <label className="ant-label font-md ps-0">Add Special Instruction For Provider Below</label>
                            <TextArea rows={5} />
                        </FormGroup>
                        <Button variant="primary" className="ms-auto min-200 mt-lg-4 mt-3" onClick={() => handleClose()}>Booking Now</Button>
                </Modal.Body>
            </Modal>

            {/* thank you for choosing us */}
        </>
    );
}

export default BookAppointment;